<h1 mat-dialog-title i18n>Please confirm, this action can not be reverted</h1>
  <div mat-dialog-content>
    <p>{{ data.confirmMessage }}<p>
  </div>
  <div mat-dialog-actions>
    <button mat-button mat-dialog-close cdkFocusInitial i18n>Cancel</button>
    <button mat-button color="accent" (click)="confirm()" i18n>OK</button>
  </div>


// WEBPACK FOOTER //
// ./src/app/private/private.component.ts.ConfirmDialogComponent.html